export class UnauthorizedError extends Error {
  constructor() {
    super('Неверный логин и/или пароль!');
    this.name = 'UnauthorizedError';
  }
}
